// extracted by mini-css-extract-plugin
export default {"inner":"AddMerchantDrawer_inner__wbqO-","footer":"AddMerchantDrawer_footer__yjS95","title":"AddMerchantDrawer_title__rs-bP","closeButton":"AddMerchantDrawer_closeButton__2FO+t"};